<template>
  <v-card
    v-show="isModelLoaded"
    class="control-bar mt-2 ml-2 pa-2"
    color="primary"
    dark
  >
    <v-tooltip
      bottom
      color="primary"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          small
          :disabled="disablePrev"
          v-on="on"
          @click="previous()"
        >
          <v-icon color="white">
            mdi-arrow-left-bold-circle
          </v-icon>
        </v-btn>
      </template>
      <span>Anterior</span>
    </v-tooltip>
    <span class="white--text pr-1 pl-1 text-caption">{{ actualItem }} / {{ totalItems }}</span>
    <v-tooltip
      bottom
      color="primary"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          small
          :disabled="disableNext"
          class="mr-4"
          v-on="on"
          @click="next()"
        >
          <v-icon color="white">
            mdi-arrow-right-bold-circle
          </v-icon>
        </v-btn>
      </template>
      <span>Próximo</span>
    </v-tooltip>
    <!-- <v-divider class="mx-2 grey lighten-5" inset vertical></v-divider> -->
    <v-tooltip
      v-if="isAnimationAvailable"
      bottom
      color="primary"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          small
          color="primary"
          v-on="on"
          @click="playPauseAnimation"
        >
          <v-icon color="white">
            {{ isAnimationPaused ? 'mdi-play' : 'mdi-pause' }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ isAnimationPaused ? 'Tocar Animação' : 'Parar Animação' }}</span>
    </v-tooltip>
    <v-tooltip
      bottom
      color="primary"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          small
          color="primary"
          href="https://www.imersys.com/ambia"
          target="_blank"
          v-on="on"
        >
          <v-icon color="white">
            mdi-help-circle
          </v-icon>
        </v-btn>
      </template>
      <span>Ajuda</span>
    </v-tooltip>
    <v-tooltip
      bottom
      color="primary"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          small
          color="primary"
          v-on="on"
          @click="requestFullscreen"
        >
          <v-icon color="white">
            {{ isInFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ isInFullscreen ? 'Sair do modo tela cheia' : 'Tela cheia' }}</span>
    </v-tooltip>
  </v-card>
</template>
<script>
import toggleFullscreen from '../../utils/fullscreen';

export default {
  name: 'ControlBarDesktop',
  props: {
    disablePrev: {
      type: Boolean,
    },
    disableNext: {
      type: Boolean,
    },
    actualItem: {
      type: Number,
      default: 0,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    isModelLoaded: {
      type: Boolean,
      default: false,
    },
    isAnimationAvailable: {
      type: Boolean,
      default: false,
    },
    isAnimationPaused: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isInFullscreen: false,
    };
  },
  methods: {
    previous() {
      this.$emit('previous');
    },
    next() {
      this.$emit('next');
    },
    requestFullscreen() {
      this.isInFullscreen = toggleFullscreen();
    },
    playPauseAnimation() {
      if (this.isAnimationPaused) this.$emit('play');
      else this.$emit('pause');
    },
  },
};
</script>
<style>
.control-bar {
  z-index: 9999;
  position: absolute;
  min-width: 190px;
}
</style>
